<template>
  <main class="main main--dashboard">
    <span
      class="d-nav__toggle no-select"

      @click="toggleDashboard()"
    >
      <span class="group">
        <span class="p">{{ `${toggleText} Dashboard` }}</span>
      </span>
    </span>
    <div class="dashboard group">
      <pages-dashboard-navigation/>
      <b
        :class="[
          `d-nav__underlay`,
          {
            'd-nav__underlay--active': dashboardTransitionState === `show` || dashboardTransitionState === `in`,
          }
        ]"
      />

      <div class="gradient-bg" />

      <transition
        name="loader"
        mode="out-in"

        @appear="onLoad()"
        @enter="onLoad()"
        @leave="onLeave()"
      >
        <div class="dashboard__panel">
          <ui-tooltip
            v-if="infoCTAVisible() && notOnStepPage()"
            level="tip">
            <span class="info-request-cta" slot="message">
              <template v-if="user.role === 1 && offTourStep(1)">
                <p>Your profile hasn't been completed yet. Please update your information <module-link link="dashboard-profile-info"><strong>here</strong></module-link></p>
              </template>
              <template v-if="showTour === `reviewer`">
                <h4>You're on your way to becoming a reviewer!</h4>
                <ul class="info-request-cta__step-counter">
                  <li :class="['info-request-cta__off-tour-step', {'info-request-cta__off-tour-step--active': offTourStep(1)}]">1: Enter your profile information on your <module-link link="dashboard-profile-info"><strong>profile page</strong></module-link></li>
                  <li :class="['info-request-cta__off-tour-step', {'info-request-cta__off-tour-step--active': offTourStep(2)}]">2: Add a location to your <module-link link="dashboard-dentist-locations"><strong>location page</strong></module-link></li>
                  <li :class="['info-request-cta__off-tour-step', {'info-request-cta__off-tour-step--active': offTourStep(3)}]">3: Apply to become a reviewer on the <module-link link="dashboard-reviewer-application"><strong>reviewer applicaton page</strong></module-link></li>
                </ul>
              </template>
              <template v-if="showTour === `dentist`">
                <h4>Your profile hasn't been completed yet. Please update your information.</h4>
                <ul class="info-request-cta__step-counter">
                  <li :class="['info-request-cta__off-tour-step', {'info-request-cta__off-tour-step--active': offTourStep(1)}]">1: Enter your profile information on your <module-link link="dashboard-profile-info"><strong>profile page</strong></module-link></li>
                  <li :class="['info-request-cta__off-tour-step', {'info-request-cta__off-tour-step--active': offTourStep(2)}]">2: Add a location to your <module-link link="dashboard-dentist-locations"><strong>location page</strong></module-link></li>
                </ul>
              </template>
            </span>
          </ui-tooltip>
          <router-view :key="$route.fullPath" />
        </div>
      </transition>

    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Models
import meta from 'models/meta';
import { tourPaths } from 'models/auth';

// Services
import { createMeta } from 'services/meta';

// Modules
import ModuleIcon from 'modules/Icon';
import ModuleLink from 'modules/Link';
import PagesDashboardNavigation from 'pages/dashboard/Navigation';
import UiTooltip from 'ui/Tooltip';

// Export
export default {
  name: `view-dashboard`,

  // Meta data
  metaInfo: {
    title: meta.dashboard.title,
    meta: createMeta(meta.dashboard.meta),
  },

  // Components
  components: {
    ModuleIcon,
    ModuleLink,
    UiTooltip,
    PagesDashboardNavigation,
  },

  // Data
  data() {
    return {
      showNav: false,
      windowWidth: 0,
      toggleText: ``,
    };
  },
  computed: {
    ...mapGetters(`app`, [
      `appState`,
    ]),
    ...mapGetters(`dashboard`, [
      `dashboardTransitionState`,
    ]),
    ...mapGetters(`auth`, [
      `user`,
      `userRole`,
      `userIsRole`,
      `showTour`,
    ]),
    inReviewCycle() {
      return this.userRole.role === 3 && this.$route.name === `dashboard-review`;
    },

    dataComplete() {
      let finished = false;

      const basicInfo = [
        `first_name`,
        `last_name`,
      ];
      const profileInfo = [
        `license_number`,
        `phone_number`,
        `specialty`,
      ];

      if (this.user.role === 1) {
        basicInfo.every(value => this.user[value]) ? finished = true : finished = false;
      }
      if (this.user.role === 2 || this.user.role === 3) {
        basicInfo.every(value => this.user[value]) ? (profileInfo.every(value => this.user.profile[value]) ? finished = true : finished = false) : finished = false;
      }
      return finished;
    },
    tourPath() {
      return tourPaths[this.showTour] || [];
    },

  },
  watch: {
    $route() {
      this.toggleDashboard(false);
    },
    dashboardTransitionState(state) {
      this.setToggleText(state);
    },
  },

  // Methods
  methods: {
    ...mapActions(`app`, [
      `openLoader`,
      `updatePage`,
      `closeLoader`,
    ]),
    ...mapActions(`dashboard`, [
      `toggleDashboard`,
    ]),
    ...mapActions(`modals`, [
      `closeModal`,
    ]),
    infoCTAVisible() {
      return (this.showTour && this.user.role === 1 && this.offTourStep === 1) ||
             (this.showTour && this.user.role === 2 && this.user.profile.tour_taken && !!this.getOffTourStep());
    },
    notOnStepPage() {
      const tourStep = this.getOffTourStep();
      return this.$route.name !== this.tourPath[tourStep];
    },
    offTourStep(step) {
      const stepCount = this.getOffTourStep();
      return stepCount === step;
    },
    getOffTourStep() {
      // Profile Information
      if(!this.dataComplete) {
        return 1;
      }

      // Location Information
      if(this.dataComplete && this.user.locationsCount < 1) {
        return 2;
      }

      if(
        this.dataComplete &&
        this.user.locationsCount > 0 &&
        this.user.profile.has_applied_for_reviewer_privileges === false &&
        this.showTour === `reviewer`
      ) {
        return 3;
      }

      return 0;
    },
    notOnPage(name) {
      return this.$route.name !== name;
    },
    onLeave() {
      this.openLoader();
      this.closeModal();
    },
    onLoad() {
      this.updatePage();

      if (this.appState.init) {
        this.closeLoader();
      }
    },
    setToggleText(state) {
      if (state === `hidden`) this.toggleText = `Show`;
      else if (state === `show`) this.toggleText = `Hide`;
    },
  },

  // Lifecycle
  created() {
    this.setToggleText(this.dashboardTransitionState);
  },
};
</script>



// WEBPACK FOOTER //
// Dashboard.vue?d01a6406